import React, { useMemo } from "react";
import { CalendarRange } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { cn } from "@/lib/utils";

/**
 * Month field — picks a {YYYY}-{MM}. Shows the label in PT-BR ("Outubro 2026").
 * Looks and sizes exactly like a normal <Select>, so it fluidly matches the
 * school dropdown on every device (iOS/Android/desktop) — no intrinsic-width
 * weirdness of `<input type="month">`.
 */
export default function MonthFieldPT({ value, onChange, className = "", testid, years = 3 }) {
  const options = useMemo(() => {
    const now = new Date();
    const list = [];
    // Include previous `years` + the current year + next 1 (admin may plan ahead)
    for (let y = now.getFullYear() + 1; y >= now.getFullYear() - years; y--) {
      for (let m = 12; m >= 1; m--) {
        const ym = `${y}-${String(m).padStart(2, "0")}`;
        const label = new Date(y, m - 1, 1)
          .toLocaleDateString("pt-BR", { month: "long", year: "numeric" })
          .replace(/^\w/, (c) => c.toUpperCase());
        list.push({ ym, label });
      }
    }
    // Trim entries after "two years from now" to keep the list compact
    return list;
  }, [years]);

  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger
        data-testid={testid}
        className={cn("w-full min-w-0 max-w-full text-left", className)}
      >
        <div className="flex items-center gap-2 min-w-0 flex-1">
          <CalendarRange className="w-4 h-4 text-slate-500 shrink-0" strokeWidth={2.2} />
          <SelectValue placeholder="Selecione o mês" />
        </div>
      </SelectTrigger>
      <SelectContent className="max-h-72">
        {options.map((o) => (
          <SelectItem key={o.ym} value={o.ym}>
            {o.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
